module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position_r "
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadList),
      expression: "loadList"
    }],
    staticStyle: {
      "width": "630px",
      "fontSize": "12px"
    },
    attrs: {
      "id": "vehicle-device",
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "vehicle-device-header"
  }, [_c('h4', {
    staticClass: "ui-modal__header-text"
  }, [_vm._v(_vm._s(_vm.vehicleDInfo.carNo) + " | " + _vm._s(_vm.vehicleDInfo.vAcc) + " 设备状态一览")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeComp
    }
  }, [_c('span', [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "device_table_box"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("设备ID")]), _vm._v(" "), _c('th', [_vm._v("设备编码")]), _vm._v(" "), _c('th', [_vm._v("SIM卡号")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPowerStr),
      expression: "showPowerStr"
    }]
  }, [_vm._v("电量")]), _vm._v(" "), _c('th', [_vm._v("定位")]), _vm._v(" "), _c('th', [_vm._v("状态详情")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deviceList), function(device, index) {
    return _c('tr', [_c('td', [_vm._v("VD" + _vm._s(device.deviceId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(device.deviceNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(device.simNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(device.wifiFlagStr))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPowerStr),
        expression: "showPowerStr"
      }],
      class: {
        red: device.wifiFlagStr === '无线' && device.power < 20
      }
    }, [_vm._v(_vm._s(device.power) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(device.locModeStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(device.status))])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-226f1981","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehiclemonitor/VehicleDevice.vue
// module id = 1441
// module chunks = 0